import React, { useEffect } from "react";
import LogoWhite from "styles/images/logotype-lg-white.png";
// Remove from local
import BackgroundVideo from "styles/images/congratulations.gif";
import NextButton from "../NextButton";
import { getWebsiteURL } from "helpers/getExternalURLs";

export default function ReviewFinishSignUp({ name, rewardsUserInvitation }) {
  const currentVideo = document.getElementById("videoBackground");
  const shouldAutoPlay = () => {
    var screenWidth = $(window).width();
    // if window width is smaller than 600 remove the autoplay attribute
    // from the video
    if (screenWidth < 600) {
      $("videoBackground").removeAttr("autoplay");
      currentVideo.pause();
    } else {
      $("videoBackground").attr("autoplay");
      currentVideo.play();
    }
  };

  useEffect(() => {
    if (currentVideo) {
      shouldAutoPlay();
    }
  }, [currentVideo]);

  return (
    <div className="relative flex flex-col col-span-full items-center justify-center w-full overflow-hidden">
      <div className="flex flex-col items-start p-5">
        <img className="mb-6 z-10" width="250" src={LogoWhite} />
        <div className="text-4xl lg:text-6xl leading-tight font-bold max-w-2xl text-white mb-4 z-10">
          <span>Congratulations,</span>
          <br />
          <span> {name}</span>
        </div>
        {!rewardsUserInvitation?.email && (
          <div className="text-2xl text-white z-10 mb-4">
            Your application is pending review. We will notify you about your
            status within 48 hours.
          </div>
        )}
        <div className="max-w-2xl text-base text-white mb-6 z-10">
          Your content already inspires purchases—now it’s time to earn from it.
          With MagicLinks, you can create affiliate links to your favorite
          products, build your own digital storefront, and get cast in campaigns
          with top brands. Apply now to join a community of video-first creators
          turning everyday recommendations into real income.
        </div>
        <div className="z-10">
          <NextButton
            label={
              rewardsUserInvitation?.email ? "Login" : "Back to MagicLinks.com"
            }
            onClick={() => window.open(getWebsiteURL())}
          />
        </div>
      </div>

      {/* <video
        id="videoBackground"
        className="absolute left-0 top-0 right-0 bottom-0 w-full h-full object-cover bg-black"
        autoPlay
        muted
        loop
        src={BackgroundVideo}
      /> */}
      <img
        className="absolute left-0 top-0 right-0 bottom-0 w-full h-full object-cover bg-black"
        src={BackgroundVideo}
      />
    </div>
  );
}
